export default function Hero() {
  return (
    <section className="min-h-screen bg-black relative overflow-hidden flex items-center">
      {/* 背景グラデーション */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-900/30 via-black to-orange-900/20"></div>
      
      {/* アニメーション背景 */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-3/4 left-1/2 w-64 h-64 bg-yellow-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      {/* 幾何学パターン */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(239, 68, 68, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(239, 68, 68, 0.3) 1px, transparent 1px)',
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center min-h-screen py-32">
            {/* 左側：メインコンテンツ */}
            <div className="space-y-8">
              <div>
                <div className="inline-block mb-6">
                  <span className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold tracking-widest" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                    CREATIVE ADVERTISING AGENCY
                  </span>
                </div>
                
                <h1 className="text-7xl md:text-8xl font-black text-white mb-8 leading-none" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  WE CREATE<br />
                  <span className="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 bg-clip-text text-transparent">
                    AMAZING
                  </span><br />
                  ADS
                </h1>
                
                <p className="text-xl text-gray-300 leading-relaxed mb-8" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  クリエイティブな発想と戦略的思考で、<br />
                  あなたのビジネスを次のステージへ。<br />
                  <strong className="text-red-400">驚きと感動を生む広告</strong>を創造します。
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-6">
                <a href="#contact" className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-4 rounded-full hover:shadow-xl hover:shadow-red-500/50 transition-all font-bold text-lg tracking-wide whitespace-nowrap" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  プロジェクト相談
                </a>
                <a href="#portfolio" className="border-2 border-red-500 text-red-400 px-8 py-4 rounded-full hover:bg-red-500 hover:text-white transition-all font-bold text-lg tracking-wide whitespace-nowrap" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  実績を見る
                </a>
              </div>

             
            </div>

            {/* 右側：イメージ */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-red-500/20 to-orange-500/20 rounded-3xl blur-xl"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-3xl border border-red-500/30 p-8 shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Dynamic%20creative%20advertising%20agency%20workspace%20with%20modern%20computers%20displaying%20colorful%20vibrant%20advertisements%20and%20marketing%20campaigns%2C%20professional%20team%20brainstorming%20creative%20ideas%2C%20large%20wall%20displays%20showing%20brand%20campaigns%2C%20contemporary%20office%20environment%20with%20red%20and%20orange%20accent%20lighting%2C%20high-tech%20creative%20studio%20atmosphere&width=600&height=700&seq=wow1&orientation=portrait"
                  alt="クリエイティブな広告代理店のワークスペース"
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* スクロールインジケーター */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-red-400 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}